import { Component } from '@angular/core';
import { readFromStorage, removeFromStorage, writeToStorage } from '../utils/local-storage.utils';
import BaseComponent from './base.component';
import { OktaAuthService } from 'src/app/core/services/http/okta-auth.service';
import { HcTableDataSource } from '@healthcatalyst/cashmere';
import * as tooltips from 'src/app/shared/constants/tooltips';
import { dayDateTimeFormat } from '../utils/date.utils';
import { takeUntil } from 'rxjs';

@Component({
    template: '',
    standalone: false
})
export class GridBaseComponent<T extends object> extends BaseComponent {
    protected gridSettingsStorageKey: string;
    public pageSize = 50;
    pageSizeOptions: number[] = [50, 100, 200];
    readonly tooltips = tooltips;
    private readonly pageSizeKeySuffix = '_PAGE_SIZE';
    private readonly sortSettingsKeySuffix = '_ACTIVE_SORT';
    readonly dayDateTimeFormat = dayDateTimeFormat;

    dataSource = new HcTableDataSource<T>([]);
    constructor(oktaAuth?: OktaAuthService) {
        super(oktaAuth);
    }

    wireUpDataGridSettingsCache() {
        this.dataSource.sort?.sortChange.pipe(takeUntil(this.unsubscribe)).subscribe(event => this.onSortChange(event));
        this.dataSource.paginator?.pageSizeChange
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(pageSize => this.cachePageSize(pageSize));
        this.loadPageSizePreference();
        this.loadSortPreference();
    }

    cachePageSize(pageSize: number) {
        writeToStorage(this.gridSettingsStorageKey + this.pageSizeKeySuffix, pageSize);
    }

    loadPageSizePreference() {
        const cachedPageSize = readFromStorage(this.gridSettingsStorageKey + this.pageSizeKeySuffix);
        const cachedPageSizeIsValid = cachedPageSize && this.pageSizeOptions.includes(cachedPageSize);
        this.pageSize = cachedPageSizeIsValid ? cachedPageSize : this.pageSize;
    }

    loadSortPreference() {
        const cachedSortSettings = readFromStorage(this.gridSettingsStorageKey + this.sortSettingsKeySuffix);
        this.dataSource.sort?.sort({
            id: cachedSortSettings?.active,
            start: cachedSortSettings?.direction,
            disableClear: false
        });
    }

    onSortChange(event: { active: string; direction: string }) {
        if (event && event.direction) {
            writeToStorage(this.gridSettingsStorageKey + this.sortSettingsKeySuffix, event);
        } else {
            removeFromStorage(this.gridSettingsStorageKey + this.sortSettingsKeySuffix);
        }

        if (this.dataSource.paginator) {
            this.dataSource.paginator.pageNumber = 1;
        }
    }
}
